import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { _columns } from './table/table-column';
import { CruiseRescheduleFormType } from '../form-type';

function reducer(
  state,
  action,
  {
    update,
    clearErrors,
    name,
    setValue,
    guestValue,
    guestName,
    isGroupedPrice,
  },
) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            // const otherVal = () => {
            //   if (action.columnId === 'guestId') {
            //     const allPreference = [
            //       ...action.extra[0].extra.preferences,
            //       ...action.extra[0].extra.preferenceStats,
            //     ];
            //     return {
            //       guestPreferences: (allPreference || []).map((item) =>
            //         tagTransformer(item),
            //       ),
            //       guestName: `${capitalize(action.extra[0].extra.title)} ${
            //         action.extra[0].extra.name
            //       }`,
            //     };
            //   }
            //   return {};
            // };
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
              // ...otherVal(),
            };

            // update(index, tempValue);
            clearErrors(name);
            setValue(`${name}.${index}`, tempValue, { shouldValidate: true });
            // clearErrors(`${name}.${action.rowIndex}.${action.columnId}`);

            if (action.columnId === 'isSelected') {
              guestValue.map((guest, idx) => {
                if (isGroupedPrice) {
                  setValue(`${guestName}.${idx}`, {
                    ...guest,
                    isSelected: action.value,
                  });
                } else {
                  if (guest.guestId === row.guestId) {
                    setValue(`${guestName}.${idx}`, {
                      ...guest,
                      isSelected: action.value,
                    });
                  }
                }
              });
            }

            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    case 'isSelected':
      return {
        ...state,
        data: state.data.map((row, index) => {
          const tempValue = {
            ...state.data[index],
            isSelected: action.value,
          };
          setValue(`${name}.${index}`, tempValue, { shouldValidate: true });
          clearErrors(name);
          // update(index, tempValue);

          guestValue.map((guest, idx) => {
            if (isGroupedPrice) {
              setValue(`${guestName}.${idx}`, {
                ...guest,
                isSelected: action.value,
              });
            } else {
              if (guest.guestId === row.guestId) {
                setValue(`${guestName}.${idx}`, {
                  ...guest,
                  isSelected: action.value,
                });
              }
            }
          });

          return tempValue;
        }),
      };
    default:
  }
}

export default function CruiseRescheduleGuestTable(props: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const { editable } = useFormState();

  const {
    control,
    formState: { isSubmitting },
    clearErrors,
    setValue,
  } = useFormContext<CruiseRescheduleFormType>();

  const name = `cruiseSales.${props.parentIndex}` as const;

  const [isInitiate, setIsInitiate] = React.useState<{
    value: boolean;
    data: any;
  }>({ value: false, data: undefined });

  const { fields, update } = useFieldArray({
    control,
    name: `${name}.cruiseSaleDetails`,
    keyName: 'customId',
  });

  const {
    cruiseSaleGuests: guestValue,
    isGroupedPrice,
    cruiseRooms,
  } = useWatch({
    control,
    name,
  });

  const columns = (dispatch?: any) =>
    _columns({
      t,
      cruiseRoomList: cruiseRooms,
      dispatch,
      name: `${name}.cruiseSaleDetails`,
    });

  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, {
        update,
        clearErrors,
        name: `${name}.cruiseSaleDetails`,
        setValue,
        guestValue,
        guestName: `${name}.cruiseSaleGuests`,
        isGroupedPrice,
      }),
    {
      columns: columns(),
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate.value) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate({
        value: true,
        data: fields.length ? fields : [],
      });
    }
  }, [fields, isInitiate]);

  React.useEffect(() => {
    if (!editable && isInitiate.value && !isSubmitting) {
      dispatch({ type: 'update_all', newData: isInitiate.data });
    }
  }, [editable, isInitiate.value, isSubmitting, t, isInitiate.data]);
  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns(dispatch) as any}
        data={state.data}
        dispatch={dispatch}
        disabled={!editable}
        name={`${name}.cruiseSaleDetails`}
        uniqueRowKey="customId"
        onCustomDisabledCell={({ accessorKey, rowOriginal }) =>
          !!(accessorKey !== 'isSelected' && !rowOriginal.isSelected)
        }
        noAddRemoveRow
      />
    </div>
  );
}
